// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3JxLj","requiredAsterisk":"Info_requiredAsterisk__1hdJk"};